<template>
	
</template>

<script>
export default {
	name: 'HistogramChart',
	props: {
		hasData: {
			type: Boolean,
			default: false
		},
		feTheme: {
			type: Object,
			default: {
				charts_no_data_text: 'No data'
			}
		}
	}
	
}
</script>